// extracted by mini-css-extract-plugin
export var downArrow = "_8a-0";
export var infoTooltipIcon = "_8a-3";
export var label = "_8a-1";
export var optionCard = "_8a-4";
export var upArrow = "_8a-2";